const WORKER_PATH = '/firebase-messaging-sw.js'

export const registerNotificationWorker =
  async (): Promise<ServiceWorkerRegistration> => {
    const scope = new URL('/', window.location.origin).href
    const scriptURL = new URL(WORKER_PATH, window.location.origin).href
    const registrations = await navigator.serviceWorker.getRegistrations()
    const existing = registrations.find(
      (registration) => registration.scope === scope,
    )

    if (
      existing &&
      [existing.active, existing.waiting, existing.installing].some(
        (worker) => worker && worker.scriptURL !== scriptURL,
      )
    ) {
      throw new Error('A different service worker already owns the root scope')
    }

    const registration = await navigator.serviceWorker.register(WORKER_PATH, {
      scope: '/',
      updateViaCache: 'none',
    })

    if (registration.active) return registration

    const worker = registration.installing ?? registration.waiting
    if (!worker) throw new Error('Notification service worker did not install')

    await new Promise<void>((resolve, reject) => {
      const finish = (error?: Error) => {
        clearTimeout(timeout)
        worker.removeEventListener('statechange', onStateChange)
        if (error) reject(error)
        else resolve()
      }
      const onStateChange = () => {
        if (worker.state === 'activated') finish()
        else if (worker.state === 'redundant') {
          finish(new Error('Notification service worker installation failed'))
        }
      }
      const timeout = setTimeout(
        () =>
          finish(new Error('Notification service worker activation timed out')),
        15000,
      )
      worker.addEventListener('statechange', onStateChange)
      onStateChange()
    })

    return registration
  }
